import { render, staticRenderFns } from "./CreativeForm.vue?vue&type=template&id=61d6f97c&"
import script from "./CreativeForm.vue?vue&type=script&lang=ts&"
export * from "./CreativeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports